import { AppRoutePath, ReporterRoutePath } from 'config/constants';
import { useMatch } from 'react-router-dom';

export const useReporterMatch = (subPath?: ReporterRoutePath, opts?: { end?: boolean }) => {
  const path = subPath && opts?.end ? `${AppRoutePath.REPORTER}/${subPath}` : AppRoutePath.REPORTER;
  const blankPath =
    subPath && opts?.end
      ? `${AppRoutePath.REPORTER_BLANK}/${subPath}`
      : AppRoutePath.REPORTER_BLANK;

  const match = useMatch({ path, end: opts?.end ?? true });
  const blankMatch = useMatch({ path: blankPath, end: opts?.end ?? true });

  return match ?? blankMatch;
};
